import { Component, OnInit } from '@angular/core';

import { GlobalService } from 'src/app/_services/global.service';

import { ActivatedRoute, Router } from '@angular/router';
import { GridService } from 'src/app/_services/grid.service';

import { ApiService } from 'src/app/_services/api.service';
import { CheckboxRenderer } from  'src/app/components/grid-addons/checkbox-renderer/checkbox-renderer.component';
import { Location } from '@angular/common'

import {
  ColDef
} from 'ag-grid-community';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import {   MessageService } from 'primeng/api';


@Component({
  selector: 'app-surveysimports',
  templateUrl: './surveysimports.component.html',
  styleUrls: ['./surveysimports.component.css'],
  providers: [ MessageService]

})
export class SurveysimportsComponent implements OnInit {
  importslist:any=[];
  columns: ColDef[] = [
 
    { field: 'title',headerName: 'Title'},
    { field: 'total_surveys',headerName: 'Total import'},
    { field: 'survey',headerName: 'Survey' },
    { field: 'import_date',headerName: 'Import date' },
  
  ];


  frameworkComponents = {
    checkboxRenderer: CheckboxRenderer
  }

  gridApi;
  gridColumnApi;
  defaultColDef = {
    width: 250,
    minWidth: 100,
    sortable:true,
    flex:1
  };

 
  
  defaultSortModel = [
    { colId: 'title', sort: 'asc', sortIndex: 0 },
  ];

 
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public globalService: GlobalService,
    public gridService: GridService,
    private apiService: ApiService,
    private location: Location
   ) { }

  ngOnInit(): void {
    const params: any = {survey_id : this.route.snapshot.paramMap.get('survey_id')};
    this.apiService.get('surveys/imports',params).subscribe(data => {
      this.importslist=data.Result;
   
      });
    

  }
  
  public back() {
    this.location.back();
  }

}
